import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Typography,
} from "@mui/material";
import React from "react";
import { AppButton, AppOutlineButton } from "../StyledComponent";

const OnboardingDialogBox = (props) => {
  const { 
    isConfirmOpen, 
    handleConfirmClose, 
    handleConfirmOnboarding, 
    hasIncompleteTasks,
    isLoading = false,
    dialogType = 'onboarding', 
    title = 'Confirm Completion',
    message,
    confirmButtonText = 'Yes, Complete'
  } = props;
  
  return (
    <Dialog
      open={isConfirmOpen}
      aria-labelledby="onboarding-dialog-title"
      aria-describedby="onboarding-dialog-description"
      PaperProps={{
        sx: {
          borderRadius: "10px",
          minWidth: 400,
        },
      }}
    >
      <DialogTitle id="onboarding-dialog-title">
        <Typography variant="h5" sx={{ fontWeight: 500 }}>
          {title}
        </Typography>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ py: 3 }}>
        <DialogContentText id="onboarding-dialog-description">
          {message || (hasIncompleteTasks 
            ? "Some tasks are incomplete. Do you still want to onboard now?"
            : "Are you sure you want to complete the onboarding process?"
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2, justifyContent: "flex-end", gap: 1 }}>
        <AppOutlineButton 
          onClick={handleConfirmClose} 
          size="small" 
          sx={{ fontSize: 15 }}
          disabled={isLoading}
        >
          Cancel
        </AppOutlineButton>
        <AppButton
          onClick={handleConfirmOnboarding}
          autoFocus
          size="small"
          variant="contained"
          sx={{ fontSize: 15 }}
          disabled={isLoading}
        >
          {isLoading ? 'Completing...' : confirmButtonText}
        </AppButton>
      </DialogActions>
    </Dialog>
  );
};

export default OnboardingDialogBox; 